module.exports = __webpack_public_path__ + "img/switch.cacda7e3.svg";